import momentJalaali from "moment-jalali";
import { useForm } from "react-hook-form";
import Loader from "react-loader-spinner";
import DatePicker from "react-datepicker2";
import "react-datepicker2/src/styles/style.css";
import { useEffect, useRef, useState } from "react";
import { Table, Button, Card } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { setCustomerPopup } from "../store/api/Modals";
import ModalSelectCustomer from "../Common/ModalSelectCustomer";
import ModalChangeCustomerStatus from "../Components/Customer/ModalChangeCustomerStatus";
import { PlusSquare, CheckLg, PencilFill, PersonPlus, ArrowRightSquare, Toggles2, Eye, Search } from 'react-bootstrap-icons';
import { addCustomerToCampaign, addNewCampaign, checkExpiredCampaigns, editSaleCampaign, getCampaign, getCampaignCustomerList, getCampaignList, getCampaignStageList, getCustomerBaseInfoes, getEventTypeList, getPreCustomerBaseInfoes } from "../store/api/CustomerApi";
import { keyIsLetterOrNumber, setErrorDialog } from "../../store/api/CommonFunctions";
import { Link, useHistory, useParams } from "react-router-dom";


const AddEditSaleCampaign = () => {
    const { id } = useParams();
    const history = useHistory();
    const stageName = useRef('');
    const frmCampaign = useRef();
    const searchData = useRef({});
    let campaignDate = useRef({});
    const dispatch = useDispatch();
    const [campaign, setCampaign] = useState({});
    const [submitError, setError] = useState({});
    let [selectedItems, selectItems] = useState([]);
    const [customerList, setCustomerList] = useState([]);
    const { register, handleSubmit, errors } = useForm();
    const [showCampaign, setShowCampaign] = useState(false);
    const [showChangeSatusModal, setChangeStatusModal] = useState(false);

    let { stageList, campaignList } =
        useSelector(state => {
            return {
                stageList: state.customerDataReducer.campaignStageList,
                campaignList: state.customerDataReducer.campaignList
            }
        });
    const onSubmit = (data) => {
        const er = {};
        if (!campaignDate.current.EndDate || campaignDate.current.EndDate === '') {
            er.EndDate = 'N';
        }
        if (!campaignDate.current.StartDate || campaignDate.current.StartDate === '') {
            er.StartDate = 'N';
        }
        if (!er.EndDate && !er.StartDate) {
            const from = new Date(campaignDate.current.StartDate);
            const to = new Date(campaignDate.current.EndDate);
            if (to <= from) {
                er.EndDate = 'N';
            }
        }
        setError(er);
        if (er.StartDate || er.EndDate) {
            return;
        }
        data.EndDate = campaignDate.current.EndDate;
        data.StartDate = campaignDate.current.StartDate;
        const onSuccess = (id) => {
            if (!campaign || !campaign.ID) {
                const cmp = { ...data };
                cmp.ID = id;
                cmp.PStartDate = campaignDate.current.PStartDate;
                cmp.PEndDate = campaignDate.current.PEndDate;
                cmp.StageName = stageName.current;
                campaignList.push(cmp);
            }
            else {
                let cmp = campaignList.find(c => c.ID === campaign.ID);
                cmp.PStartDate = campaignDate.current.PStartDate;
                cmp.PEndDate = campaignDate.current.PEndDate;
                cmp.StageName = stageName.current !== '' ? stageName.current : campaign.StageName;
                cmp.CampaignName = data.CampaignName;
                cmp.SaleTarget = data.SaleTarget;
                cmp.Description = data.Description;
                cmp.Budget = data.Budget;
            }
            setShowCampaign(false);
            campaignDate.current.EndDate = "";
            campaignDate.current.StartDate = "";
            frmCampaign.current.reset();
        }
        if (campaign && campaign.ID) {
            data.ID = campaign.ID;
            dispatch(editSaleCampaign(data, onSuccess));
        }
        else {
            dispatch(addNewCampaign(data, onSuccess));
        }
    }
    const editCampaign = (c) => {
        history.replace("/CRM/AddEditSaleCampaign/" + c.ID);
        setCampaign(c);
        setShowCampaign(true);
    }
    const setToAddMode = () => {
        setCampaign({});
        setShowCampaign(true);
    }
    const getCustList = (campaignID) => {
        setCustomerList("PENDING");
        getCampaignCustomerList(campaignID, setCustomerList);
    }

    const showCustomerPop = (campaignID) => {
        const onSelectCustList = (type, list) => {
            if (list && list.length > 0) {
                const data = {};
                data.ID = campaignID;
                data.Name = type;
                data.StringValue = "getcustomers";
                data.ListValue = list;
                dispatch(addCustomerToCampaign(data, setCustomerList));
            }
        }
        dispatch(setCustomerPopup({ show: true, onSelect: onSelectCustList }));
    }
    const setSelectedItems = (add, item) => {
        if (add) {
            selectItems([...selectedItems, item]);
        }
        else {
            selectItems(selectedItems.filter(i => item !== i));
        }

    }
    const selectAll = (value) => {
        if (!value) {
            selectItems([]);
        }
        else if (customerList) {
            selectItems(customerList.map(c => c));
        }
    }
    const changeStatusModal = () => {
        if (!selectedItems || selectedItems.length === 0) {
            setErrorDialog(dispatch, "دست کم یک مشتری/بالقوه باید انتخاب شود", "تغییر وضعیت مشتریان");
            return;
        }
        const hasCust = selectedItems.find(c => c.CustOrPreCust === "مشتری");
        const hasPreCust = selectedItems.find(c => c.CustOrPreCust === "مشتری بالقوه");
        if (hasCust && hasPreCust) {
            setErrorDialog(dispatch, "تغییر وضعیت همزمان مشتریان و مشتریان بالقوه امکانپذیر نیست", "تغییر وضعیت مشتریان");
            return;
        }
        setChangeStatusModal(true);
    }
    const showCustomer = (item) => {
        if (item.CustOrPreCust === "مشتری بالقوه") {
            history.push("/CRM/AddEditPreCustomer/" + item.ID);
        }
        else {
            history.push("/CRM/AddEditCustomer/" + item.ID);
        }
    }
    const search = (e) => {
        if(e.key && e.key !=="Enter")
        {
            return;
        }
        dispatch(getCampaignList(searchData.current));
    }

    useEffect(() => {
        document.body.classList = "notMain";
        if (Number(id) > 0) {
            const onSuccess = (c) => {
                editCampaign(c);
                getCustList(id);
            }
            dispatch(getCampaign(id, onSuccess));
        }
        dispatch(getEventTypeList());
        dispatch(getCustomerBaseInfoes());
        dispatch(getPreCustomerBaseInfoes());
        dispatch(getCampaignStageList());
        dispatch(getCampaignList({ StageName: "" }));
        dispatch(checkExpiredCampaigns());
    }, []);

    return (<div className="container-fluid mt-2" style={{ minHeight: '80vh' }}>
        <br />
        <Card>
            <Card.Header className="headerStyle">مدیریت اطلاعات کمپین فروش</Card.Header>
            <Card.Body className="bodyStyle">
                <ModalSelectCustomer />
                <ModalChangeCustomerStatus show={showChangeSatusModal} setShow={setChangeStatusModal} customers={selectedItems}
                    onChangeStatus={(res) => { setCustomerList(res); selectItems([]); }}
                    campaignID={campaign?.ID} />
                {!showCampaign &&
                    <div className="row" style={{ border: "1px solid #b0aaaa", borderRadius: "3px", padding: "6px 6px 19px", margin: "5px" }}>
                        <div className="form-group col-md-3">
                            <input type="text" placeholder="نام کمپین" className="form-control" onChange={e => searchData.current.CampaignName = e.target.value} defaultValue={searchData.current?.CampaignName ?? ""} onKeyDown={search}/>
                        </div>
                        <div className="form-group col-md-3" >
                            <select className="form-control"
                                onChange={e => searchData.current.StageID = e.target.value} defaultValue={searchData.current?.StageID ?? ""}>
                                <option value="">مرحله کاری را انتخاب کنید</option>
                                {stageList && Array.isArray(stageList) &&
                                    stageList.map((item, i) => <option key={i} value={item.ID}>{item.StageName}</option>)
                                }
                            </select>
                        </div>
                        <div className="form-group col-md-2" style={{ border: "1px solid gray", borderRadius: "3px", paddingTop: "7px", marginTop: "17px", paddingRight: 0 }}>
                            <input type="checkbox" className="form-check-input" onChange={e => searchData.current.JustValid = e.target.checked} />
                            &nbsp;
                            <label style={{ marginTop: "3px", color: "blue" }}>فقط موارد معتبر نمایش داده شود</label>
                        </div>
                        <div className="form-group col-md-2" style={{ paddingRight: "0" }}>
                            <Button variant="secondary" className="group-Btn" onClick={search} style={{ marginTop: "3px" }}><Search size={17} />&nbsp;جستجوی کمپین</Button>
                        </div>
                    </div>
                }
                {showCampaign &&
                    <form ref={frmCampaign} onSubmit={handleSubmit(onSubmit)} readOnly
                        style={{ border: "1px solid #b0aaaa", borderRadius: "3px", padding: "10px" }}>
                        <div className="row" >
                            <div className="form-group col-md-3" >
                                <label>نام کمپین</label><span style={{ color: "red", fontSize: "13px" }}>*</span>
                                <input type="text" className="form-control" name="CampaignName" ref={register({ required: true })}
                                    defaultValue={campaign && campaign.CampaignName ? campaign.CampaignName : ""} />
                                {errors.CampaignName && <small className="errors"> نام را وارد کنید </small>}
                            </div>
                            <div className="col-md-3 form-group">
                                <label>تاریخ آغاز</label><span style={{ color: "red", fontSize: "13px" }}>*</span>
                                <DatePicker isGregorian={false} timePicker={false} className="form-control"
                                    value={campaign && campaign.StartDate ? momentJalaali(campaign.StartDate.substring(0, 10)) : null}
                                    onChange={value => { campaignDate.current.StartDate = value.local("en").format("YYYY/MM/DD"); campaignDate.current.PStartDate = value.local("fa").format("jYYYY/jMM/jDD"); }} />
                                {submitError.StartDate && <small className="errors"> تاریخ آغاز را وارد کنید </small>}
                            </div>
                            <div className="col-md-3 form-group">
                                <label>تاریخ پایان</label><span style={{ color: "red", fontSize: "13px" }}>*</span>
                                <DatePicker isGregorian={false} timePicker={false} className="form-control"
                                    value={campaign && campaign.EndDate ? momentJalaali(campaign.EndDate.substring(0, 10)) : null}
                                    onChange={value => { campaignDate.current.EndDate = value.local("en").format("YYYY/MM/DD"); campaignDate.current.PEndDate = value.local("fa").format("jYYYY/jMM/jDD"); }}
                                    oni />
                                {submitError.EndDate && <small className="errors"> تاریخ پایان  باید بزرگتر از تاریخ آغاز باشد</small>}
                            </div>
                            <div className="form-group col-md-3" >
                                <label>فروش هدف</label>
                                <input type="number" className="form-control" name="SaleTarget" ref={register({})}
                                    defaultValue={campaign && campaign.SaleTarget ? campaign.SaleTarget : ""} />
                            </div>
                            <div className="form-group col-md-3" >
                                <label>نوع هدف</label>
                                <select className="form-control" name="TargetType" ref={register({})}
                                    defaultValue={campaign && campaign.TargetType ? campaign.TargetType : ""}>
                                    <option value="">انتخاب کنید</option>
                                    <option value={false}>عدد</option>
                                    <option value={true}>مبلغ</option>
                                </select>
                            </div>
                            <div className="form-group col-md-3" >
                                <label>بودجه</label>
                                <input type="number" className="form-control" name="Budget" ref={register({})}
                                    defaultValue={campaign && campaign.Budget ? campaign.Budget : ""} />
                            </div>
                            <div className="form-group col-md-3" >
                                <label>مرحله کاری</label>
                                <select className="form-control" name="StageID" ref={register({})}
                                    onChange={e => stageName.current = e.target.options[e.target.selectedIndex].text}
                                    defaultValue={campaign && campaign.StageID ? campaign.StageID : ""}>
                                    <option value="">انتخاب کنید</option>
                                    {stageList && Array.isArray(stageList) &&
                                        stageList.map((item, i) => <option key={i} value={item.ID}>{item.StageName}</option>)
                                    }
                                </select>
                            </div>
                            <div className="form-group col-md-3" >
                                <label>توضیحات</label>
                                <input type="text" className="form-control" name="Description" ref={register({})}
                                    defaultValue={campaign && campaign.Description ? campaign.Description : ""} />
                            </div>
                        </div>
                        <Button type="submit" variant="success" className="group-Btn mt-2"><CheckLg />&nbsp;ثبت اطلاعات</Button>
                        {Number(campaign?.ID) > 0 && <Button className="group-Btn mt-2" onClick={() => showCustomerPop(campaign.ID)}><PersonPlus size={16} /></Button>}
                        <Button variant="danger" className="group-Btn mt-2" onClick={() => { history.replace("/CRM/AddEditSaleCampaign/0"); setShowCampaign(false) }}><ArrowRightSquare size={18} />&nbsp;بازگشت به جستجو</Button>
                    </form>
                }
                {!showCampaign && <Button style={{ display: "block" }} className="group-Btn mt-2" onClick={setToAddMode}><PlusSquare size={19} /></Button>}
                <Table className="fixedTable mt-1" responsive={true} style={{ display: campaign?.ID && showCampaign ? "none" : "block" }}>
                    <thead>
                        <tr >
                            <th style={{ width: "5%" }}><span style={{ color: "blue" }}>{campaignList && Array.isArray(campaignList) ? campaignList.length : "0"}</span></th>
                            <th style={{ width: "30%" }}>نام کمپین</th>
                            <th style={{ width: "10%" }}>تاریخ آغاز</th>
                            <th style={{ width: "10%" }}>تاریخ پایان</th>
                            <th style={{ width: "20%" }}>مرحله</th>
                            <th style={{ width: "15%" }}>فروش هدف</th>
                            <th style={{ width: "10%" }}>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {campaignList === "PENDING" &&
                            <tr>
                                <td style={{ width: "100%", textAlign: "center" }}><Loader type="BallTriangle" width="25" height="25" color="#bb1370" /></td>
                            </tr>
                        }
                        {campaignList && Array.isArray(campaignList) &&
                            campaignList.map((item, i) =>
                                <tr key={i} className="resultTableRow" onClick={() => getCustList(item.ID)}>
                                    <td style={{ width: "5%" }}>{i + 1}</td>
                                    <td style={{ width: "30%" }}>{item.CampaignName}</td>
                                    <td style={{ width: "10%" }}>{item.PStartDate}</td>
                                    <td style={{ width: "10%" }}>{item.PEndDate}</td>
                                    <td style={{ width: "20%" }}>{!(item.StageName || (item.StageName === "")) ? "--" : item.StageName}</td>
                                    <td style={{ width: "15%" }}>{!item.SaleTarget || item.SaleTarget === "" ? "--" : item.SaleTarget}</td>
                                    <td style={{ width: "10%" }}>
                                        <PencilFill size={16} color="orange" className="rowBtn" onClick={() => editCampaign(item)} />
                                        &nbsp;
                                        <PersonPlus size={18} color="blue" className="rowBtn" onClick={() => showCustomerPop(item.ID)} />
                                    </td>
                                </tr>)
                        }
                    </tbody>
                </Table>
                <div style={{ display: !campaign || !campaign.ID || !showCampaign ? "none" : "block" }}>
                    <Table className="fixedTable scrolledTable mt-2" responsive={true} >
                        <thead>
                            <tr >
                                <th style={{ width: "5%" }}><span style={{ color: "blue" }}>{customerList && Array.isArray(customerList) ? customerList.length : 0}</span></th>
                                <th style={{ width: "3%" }}>
                                    <input type='checkbox' className='form-check-input' style={{ cursor: "pointer" }} onChange={e => selectAll(e.target.checked)} />
                                </th>
                                <th style={{ width: "15%" }}>نام مشتری</th>
                                <th style={{ width: "10%" }}>تلفن</th>
                                <th style={{ width: "10%" }}>موبایل</th>
                                <th style={{ width: "29%" }}>آدرس</th>
                                <th style={{ width: "10%" }}>نوع</th>
                                <th style={{ width: "10%" }}>وضعیت</th>
                                <th style={{ width: "8%" }}>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            {customerList === "PENDING" &&
                                <tr>
                                    <td style={{ width: "100%", textAlign: "center" }}><Loader type="BallTriangle" width="25" height="25" color="#bb1370" /></td>
                                </tr>
                            }
                            {customerList && Array.isArray(customerList) &&
                                customerList.map((item, i) =>
                                    <tr key={i} className="resultTableRow">
                                        <td style={{ width: "5%" }}>{i + 1}</td>
                                        <td style={{ width: "3%", verticalAlign: "middle" }} >
                                            <input type='checkbox' className='form-check-input' style={{ cursor: "pointer" }}
                                                checked={selectedItems.find(i => i === item)}
                                                onChange={(e) => setSelectedItems(e.target.checked, item)} />

                                        </td>
                                        <td style={{ width: "15%" }}>{item.Name}</td>
                                        <td style={{ width: "10%" }}>{item.Phone === "" || !item.Phone ? "--" : item.Phone}</td>
                                        <td style={{ width: "10%" }}>{item.Mobile === "" || !item.Mobile ? "--" : item.Mobile}</td>
                                        <td style={{ width: "29%" }}>{item.Address === "" || !item.Address ? "--" : item.Address.substring(0, 50)}</td>
                                        <td style={{ width: "10%" }}>{item.CustOrPreCust}</td>
                                        <td style={{ width: "10%" }}>{item.Status ?? "--"}</td>
                                        <td style={{ width: "8%" }}>
                                            <Link to={(item.CustOrPreCust === "مشتری بالقوه" ? "/CRM/AddEditPreCustomer/" : "/CRM/AddEditCustomer/") + item.ID}>
                                                <Eye size={16} color="blue" className="rowBtn" />
                                            </Link>
                                        </td>
                                    </tr>)
                            }
                        </tbody>
                    </Table>
                    <Button className="group-Btn btn-violet" style={{ float: "right" }} onClick={changeStatusModal}><Toggles2 size={19} />&nbsp;تغییر وضعیت</Button>
                </div>
            </Card.Body>
        </Card>
    </div>)
}
export default AddEditSaleCampaign;